import React, {Component} from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import _ from 'lodash';
import {IconeCarregar, IconeInformacao} from './Icones';

export default class FormOnlyPositiveNumberSimples extends Component {
    constructor(props) {
        super(props);

        this.state={
            alerta: this.props.alerta,
            limiteInput: false,
            value: this.props.dado ? this.props.dado : ""

        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.alerta !== this.props.alerta) {
            this.setState({
                alerta: this.props.alerta
            });
        }
    };

    handlePress = (event) => {
        if(event.key === 'Enter' && this.props.onEnter){
            this.props.onEnter()
        }
    }

    handleBlur = (event) => {
        var invalido = (this.props.validador) ? this.props.validador(event.target.value) : false;
        if (!invalido) {
            this.salva(event);
            this.props.validacaoStore && this.props.validacaoStore(true)
        }
        if (invalido && this.props.validacaoStore) {
            this.props.validacaoStore(false)
        }
        this.setState({
            alerta: invalido
        });
    }

    handleChange = (event) => {
        let valor = event.target.value.replace(/\D/g,'')

        const patchedEvent = {
            ...event,
            target: {
                ...event.target,
                value: valor,
            },
        };

        if (this.props.limiteMaximo){
            if (valor.length <= this.props.limiteMaximo){
                this.setState({
                    value: valor,
                    limiteInput: this.props.limiteMaximo - this.props.maximoColar
                });
                this.props.onChange(patchedEvent, event)
            }
        } else {
            this.setState({
                value: valor,
                limiteInput: false
            });
            this.props.onChange(patchedEvent, event)
        }
    };

    render() {
        return(
            <Col className={this.props.className ? `${this.props.className} ${this.props.marginBottom ? this.props.marginBottom : "mb-4"}` : "mb-4"}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={this.props.md ? this.props.md : 'auto'}
                lg={this.props.lg ? this.props.lg : 'auto'}
                xl={this.props.xl ? this.props.xl : 'auto'}
                >
                <div className="w-100">
                    { this.props.titulo && 
                        <Label>
                            { this.props.titulo } 
                            { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } 
                            {this.props.carregando && <IconeCarregar className="label-carregar" tamanho="2x" />} 
                        </Label> 
                    }
                    <Input
                        disabled = {this.props.bloqueado ? "disabled" : ""}
                        type="text"
                        //É necessário ser do tipo text para que a validação de -, . e "e" seja feita.
                        //O campo do tipo "number" permite que estes caracteres que não são desejados possam ser usados.
                        //Da forma atual somente números positivos podem ser usados.
                        value={this.state.value}
                        onKeyPress={this.handlePress}
                        min={ this.props.min ? this.props.min : 0 } max={ this.props.max ? this.props.max : 999999 }
                        maxLength={this.state.limiteInput ? this.state.limiteInput : this.props.limiteMaximo}
                        onChange={ this.handleChange }
                        onBlur={ this.props.onBlur ? this.props.onBlur :(event) => this.handleBlur(event, event) } />
                </div>
                { (this.state.alerta && this.state.alerta.length>0) && <Label className="label-danger">{ this.state.alerta }</Label> }
                <div className="d-flex align-items-center">
                    {this.props.iconeInfo && <div><IconeInformacao className="pr-1" /></div>}
                    { this.props.informacoes ? <Label className="informacoes">{ this.props.informacoes }</Label> : "" }
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormNumberSimples.js